module.exports = "/_next/static/images/doulbleQuote-393874c8dcd09168cc3a24efd03ea092.svg";